import Axios from 'axios';
import { Payload } from '../constants/payload.model';

const INVENTORY_API = `${process.env.VUE_APP_INVENTORY_API}`;

const UTILS_API = `${process.env.VUE_APP_UTILS_API}`;

const apiProxy = (options) => {
    try {
        return Axios.post('/ProxyApi', options);
    } catch (error) {
        throw new Error(error);
    }
};


export default {

    async getVehicles(sellerIdentifier, PageSize = 20) {

        const options = new Payload(`${INVENTORY_API}/vehicles?Seller=${sellerIdentifier}&PageSize=${PageSize}`, 'GET');

        try {
            const response = await apiProxy(options);
            const data = await response.data;
            return data;

        } catch (error) {
            if(error.response)
                throw new Error(error.response.data.customMessage || error.response.data.message);
                
            throw new Error(error);
        }
    },
    async updateInventoryStatus(sellerIdentifier, republish) {

        const options = new Payload(`${UTILS_API}/Vehicles/${sellerIdentifier}`, republish ? 'POST' : 'PATCH');

        try {
            const response = await apiProxy(options);
            const data = await response.data;
            return data;

        } catch (error) {
            if(error.response)
                throw new Error(error.response.data.customMessage || error.response.data.message);
            
            throw new Error(error);
        }
    },

}